import { render } from "./Icon.md?vue&type=template&id=3aca7906"
const script = {}
script.render = render

export default script